type Doc = "privacy" | "terms" | "cookies";

const HASHES: Record<string, Doc> = {
  "#privacy-policy": "privacy",
  "#privacy": "privacy",
  "#terms": "terms",
  "#terms-and-conditions": "terms",
  "#cookie-policy": "cookies",
  "#cookies": "cookies",
};

export function initLegal(): void {
  const dialog = document.querySelector<HTMLDialogElement>("[data-legal]");
  if (!dialog || typeof dialog.showModal !== "function") return;
  const tabs = Array.from(dialog.querySelectorAll<HTMLButtonElement>("[data-legal-tab]"));
  const docs = Array.from(dialog.querySelectorAll<HTMLElement>("[data-legal-doc]"));
  const body = dialog.querySelector<HTMLElement>("[data-legal-body]");
  const root = document.documentElement;

  const show = (doc: Doc, focus = false) => {
    tabs.forEach((tab) => {
      const on = tab.dataset.legalTab === doc;
      tab.setAttribute("aria-selected", String(on));
      tab.tabIndex = on ? 0 : -1;
      if (on && focus) tab.focus();
    });
    docs.forEach((d) => (d.hidden = d.dataset.legalDoc !== doc));
    if (body) body.scrollTop = 0;
  };

  const open = (doc: Doc) => {
    show(doc);
    if (!dialog.open) {
      dialog.showModal();
      root.classList.add("has-legal");
      window.dispatchEvent(new Event("otridon:lock"));
    }
    tabs.find((t) => t.dataset.legalTab === doc)?.focus();
  };
  const close = () => {
    dialog.classList.add("is-closing");
    window.setTimeout(
      () => {
        dialog.classList.remove("is-closing");
        dialog.close();
      },
      window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 180,
    );
  };
  dialog.addEventListener("close", () => {
    root.classList.remove("has-legal");
    window.dispatchEvent(new Event("otridon:unlock"));
  });
  dialog.addEventListener("cancel", (e) => {
    e.preventDefault();
    close();
  });
  dialog.addEventListener("click", (e) => {
    if (e.target === dialog) close();
  });
  dialog.querySelectorAll("[data-legal-close]").forEach((b) => b.addEventListener("click", close));

  document.querySelectorAll<HTMLElement>("[data-legal-open]").forEach((link) =>
    link.addEventListener("click", (e) => {
      e.preventDefault();
      open((link.dataset.legalOpen as Doc) ?? "privacy");
    }),
  );

  tabs.forEach((tab, i) => {
    tab.addEventListener("click", () => show(tab.dataset.legalTab as Doc));
    tab.addEventListener("keydown", (e) => {
      const step = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0;
      if (!step) return;
      e.preventDefault();
      const next = tabs[(i + step + tabs.length) % tabs.length];
      if (next) show(next.dataset.legalTab as Doc, true);
    });
  });

  const fromHash = () => {
    const doc = HASHES[location.hash.toLowerCase()];
    if (doc) open(doc);
  };
  window.addEventListener("hashchange", fromHash);
  fromHash();
}
